const FALSE_STRINGS = new Set(['0', 'no', 'false']);

const parseBoolean = (value: unknown): boolean | null => {
  if (value === 0 || value === false) {
    return false;
  }

  if (typeof value === 'string' && FALSE_STRINGS.has(value.toLowerCase())) {
    return false;
  }

  if (value === null || value === undefined) {
    return null;
  }

  return true;
};

export default parseBoolean;
